import script from "./WisdomBasePage.vue?vue&type=script&setup=true&lang=js"
export * from "./WisdomBasePage.vue?vue&type=script&setup=true&lang=js"

import "./WisdomBasePage.vue?vue&type=style&index=0&id=4b31c2fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b31c2fa"]])

export default __exports__